/*
* Note re: explicit numbering:  THESE ENUMS ARE STORED IN LOCALSTORAGE as user settings.
* If their values change, the storage code must accommodate "v1" settings.
*/

export enum ChordHistoryInteractMode {
  SOUND = 0 /* 1 click to sound */,
  EDIT = 1 /* click to open an explore/edit popup menu */,
  DELETE = 2 /* 1 click to delete */,
  CHOOSE = 3,
}
export enum ChordHistoryLabelMode {
  /** example: Fm7 G7 Cmaj7 */
  RootLetter = 0,
  /** example: iim7 V7 Imaj7 */
  RootDegree = 1,
}
export enum ChordSoundingNoteOrder {
  StartFromRoot = 0,
  MatchActualNotes = 1,
}
export enum ChordSoundingArpeggiation {
  None = 0,
  Fast = 1,
  Slow = 2,
}
export enum ChordEditBlastRadius {
  OnlyThisInstance = 0,
  AllInstances = 1,
}

type ChordHistorySoundingOptions = {
  arpeggiation: ChordSoundingArpeggiation;
  ordering: ChordSoundingNoteOrder;
};
type ChordHistoryEditModeOptions = {
  /** this one should appear directly on the chord edit popup as well */
  blastRadius: ChordEditBlastRadius;
};
export enum ChordSoundingOscillatorShape {
  SINE = 0,
  SAWTOOH_LOW = 1,
  SAWTOOTH_ALL = 2,
}
type ChordHistoryNoteRowOptions = {
  /** B3 as opposed to just B */
  hideNoteOctave: boolean;
  /** shrink the window, only show chords */
  hideNotes: boolean;
  /** avoid shrill/low sounds */
  oscillatorShape: ChordSoundingOscillatorShape;
  /** warn if delete would remove all chords */
  // warnIfDeleteZeroesChords: boolean; // Deleting notes isn't supported yet, maybe not needed
};

export type ChordHistoryOptions = {
  interactMode: ChordHistoryInteractMode;
  labelMode: ChordHistoryLabelMode;
  autoScroll: boolean;
  sounding: ChordHistorySoundingOptions;
  edits: ChordHistoryEditModeOptions;
  /** specific to the note window above the chords */
  noteRow: ChordHistoryNoteRowOptions;
};
